export default "__VITE_ASSET__DfrPF$Ro__"